import ActionTypes from './actions.types';
import initialState from './initial-state';

import type { RatesPricingState } from './common.types';
import type { BPID } from '@energy-retailer/schema';

export type Action = {
  type: ActionTypes;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload could have any types
  payload?: any;
};

const RatesPricingReducer = (
  state: RatesPricingState,
  action: Action
): RatesPricingState => {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- payload could have any types
    payload,
    type,
  } = action;

  switch (type) {
    case ActionTypes.SetItems:
      return {
        ...state,
        items: payload as BPID[],
      };
    case ActionTypes.SetOptions:
      return {
        ...state,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- options could have any of 4 values
        options: {
          ...state.options,
          ...payload,
        },
      };
    case ActionTypes.SetFilters:
      return {
        ...state,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- filters could have any of 4 values
        filters: {
          ...state.filters,
          ...payload,
        },
      };
    case ActionTypes.ResetFilters: {
      return {
        ...state,
        filters: {
          ...initialState.filters,
        },
      };
    }
    default:
      throw new Error(`Action ${type as string} not handled by Reducer`);
  }
};

export default RatesPricingReducer;
